/*
 * cart-gift-limit.js
 * ------------------
 * Keeps the free-gift line ("CRTN MAX - 5g", variant 57227310170492 / sku 11259)
 * capped at a single unit per order.
 *
 * The quantity controls for this line are already locked in the UI
 * (disabled input + max="1" so the +/- buttons disable — see
 * snippets/cart-products.liquid and snippets/quantity-selector.liquid).
 *
 * This script is the safety net: if the gift ever ends up with quantity > 1 in
 * the cart (a cart that predates this fix, a direct /cart/add link, etc.) it
 * silently corrects the line back to 1. It reuses the theme's own
 * cart-items-component.updateQuantity() so the cart page AND the cart drawer
 * re-render, and falls back to a plain /cart/change.js + reload if that
 * component API is ever unavailable.
 */
(function () {
  if (window.__cartGiftLimitInit) return;
  window.__cartGiftLimitInit = true;

  var GIFT_VARIANT_ID = 57227310170492;
  var MAX_QTY = 1;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var working = false;

  function correct(line) {
    // Preferred path: let the theme perform the change so every cart surface
    // (main cart + drawer) morphs to the corrected quantity.
    var comp = document.querySelector('cart-items-component');
    if (comp && typeof comp.updateQuantity === 'function') {
      comp.updateQuantity({ line: line, quantity: MAX_QTY, action: 'change' });
      return;
    }
    // Fallback: correct the cart server-side, then reload to refresh the UI.
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: MAX_QTY })
    }).then(function () { location.reload(); });
  }

  function enforce() {
    if (working) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var idx = items.findIndex(function (i) { return i.variant_id === GIFT_VARIANT_ID; });
        if (idx === -1 || items[idx].quantity <= MAX_QTY) return;
        working = true;
        correct(idx + 1);
        // Release the guard after the correction has had time to settle.
        setTimeout(function () { working = false; }, 1500);
      })
      .catch(function () { working = false; });
  }

  document.addEventListener('DOMContentLoaded', enforce);
  // Re-check after any theme-driven cart change (ignore our own correction).
  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.source === 'cart-gift-limit') return;
    enforce();
  });
})();
